import React from 'react';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';

import messages from './messages';
import { CHARGE_PERIOD_TYPES } from '../constants';

type Props = {
  intl: any,
  chargePeriodType: string,
  closeDeleteChargeModal: Function,
  handleChargeDelete: Function,
  open?: boolean,
};

export const DeleteChargeModal = ({
  intl,
  chargePeriodType,
  closeDeleteChargeModal,
  handleChargeDelete,
  open = true,
}: Props) => {
  const getBodyMessage = () => {
    switch (chargePeriodType) {
      case CHARGE_PERIOD_TYPES.PRIOR_CURRENT:
        return messages.confirmEnd;
      case CHARGE_PERIOD_TYPES.FUTURE:
        return messages.confirmDelete;
      case CHARGE_PERIOD_TYPES.PRORATE:
        return messages.confirmDeleteProrated;
      default:
        return messages.confirmDelete;
    }
  };

  const actionsProps = [
    {
      children: 'Cancel',
      onClick: closeDeleteChargeModal,
    },
    {
      children: 'Delete',
      onClick: handleChargeDelete,
    },
  ];

  return (
    <ModalConfirm
      open={open}
      title={intl.formatMessage(messages.confirmDeleteProratedHeader)}
      onClose={closeDeleteChargeModal}
      actionsProps={actionsProps}
    >
      {intl.formatMessage(getBodyMessage())}
    </ModalConfirm>
  );
};
